import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItemButton,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Typography,
  Box,
} from '@mui/material';
import { Colors } from '../../../../theme/colors';

interface Employer {
  pk_User_ID: number;
  Employer_Name?: string;
  Employer_ImageLink?: string;
  Employer_Initials?: string;
  Employer_BackgroundColour?: string;
  Employer_Colour?: string;

  Enterprise_Name?: string;
  Enterprise_ImageLink?: string;
  Enterprise_Initials?: string;
  Enterprise_BackgroundColour?: string;
  Enterprise_Colour?: string;
}

interface EmployerSelectionModalProps {
  open: boolean;
  onClose: () => void;
  employers: Employer[];
  onSelectEmployer: (employer: Employer) => void;
}

const EmployerSelectionModal: React.FC<EmployerSelectionModalProps> = ({
  open,
  onClose,
  employers,
  onSelectEmployer,
}) => {
  const renderEmployerAvatar = (employer: Employer) => {
    const logo = employer?.Enterprise_ImageLink ?? employer?.Employer_ImageLink;

    if (logo) {
      return <Avatar src={logo} alt="logo" sx={{ width: 50, height: 50 }} />;
    }

    const initials =
      employer?.Enterprise_Initials ??
      employer?.Employer_Initials ??
      employer?.Employer_Name?.charAt(0) ??
      employer?.Enterprise_Name?.charAt(0) ??
      '?';

    const bgColor =
      employer?.Enterprise_BackgroundColour ??
      employer?.Employer_BackgroundColour ??
      Colors.Maximum_blue_purple;

    const textColor =
      employer?.Enterprise_Colour ??
      employer?.Employer_Colour ??
      Colors.black;

    return (
      <Avatar
        sx={{
          width: 50,
          height: 50,
          bgcolor: bgColor,
          color: textColor,
          fontWeight: 600,
          fontSize: '16px',
          textTransform: 'uppercase',
        }}
      >
        {initials}
      </Avatar>
    );
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          fontSize: '18px',
          fontWeight: 600,
          textAlign: 'center',
        }}
      >
        Select an Employer
      </DialogTitle>

      <DialogContent dividers>
        {employers.length > 0 ? (
          <List>
            {employers.map((employer) => (
              <ListItemButton
                key={employer.pk_User_ID}
                onClick={() => {
                  onSelectEmployer(employer);
                  onClose();
                }}
                sx={{ borderRadius: 2, mb: 1 }}
              >
                <ListItemAvatar>{renderEmployerAvatar(employer)}</ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography fontSize="14px" color={Colors.outerSpace}>
                      {employer?.Employer_Name ?? employer?.Enterprise_Name}
                    </Typography>
                  }
                />
              </ListItemButton>
            ))}
          </List>
        ) : (
          <Box textAlign="center" py={3}>
            <Typography variant="body2" color="text.secondary">
              No employers available
            </Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default EmployerSelectionModal;
